<template>
  <div >
    <!--цена-->
    <b-list-group >
      <b-list-group-item class="d-flex justify-content-between align-items-center">
        {{title}}
        <b-badge variant="primary" pill :style="color">{{ (price*count).toFixed(2)}} грн</b-badge>
      </b-list-group-item>
      <!--                  <b-list-group-item class="d-flex justify-content-between align-items-center">-->
      <!--                    Прибыль с колорантов-->
      <!--                    <b-badge variant="primary" pill>{{ (val*profit).toFixed(2)}} грн</b-badge>-->
      <!--                  </b-list-group-item>-->
    </b-list-group>
  </div>
</template>

<script>
export default {
  props: ['price', 'count','title','color'],
  name: "Price",
  data() {
    return {

    };
  },

  methods: {

  }
}
</script>

<style scoped>

</style>